'use strict';

import type { IndEmail } from '../../Entities/Ind/IndEmail';
import { EntityCollection } from '../EntityCollection';

export class IndEmailCollection extends EntityCollection<IndEmail> {}
